import { c as _c } from "react/compiler-runtime";
import { Icon } from '../shared/icon';
export const ThreatIssueIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Icon iconClass="material-symbols-gpp-maybe-outline-rounded" sx={{
      "& i": {
        color: "var(--mui-palette-error-main)"
      }
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};